import { render, staticRenderFns } from "./GkAvatar.vue?vue&type=template&id=38f01dd2&scoped=true&"
import script from "./GkAvatar.vue?vue&type=script&lang=js&"
export * from "./GkAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GkAvatar.vue?vue&type=style&index=0&id=38f01dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f01dd2",
  null
  
)

export default component.exports